import type { JSONContent } from '@tiptap/core';

export const LIQUID_VARIABLE_NODE = 'liquidVariable';

const VARIABLE_TOKEN = /\{\{\s*([A-Za-z_][A-Za-z0-9_]*)\s*\}\}/g;

export const liquidInlineContent = (text: string): JSONContent[] => {
	VARIABLE_TOKEN.lastIndex = 0;
	const content: JSONContent[] = [];
	let cursor = 0;
	let match: RegExpExecArray | null;

	while ((match = VARIABLE_TOKEN.exec(text)) !== null) {
		if (match.index > cursor) {
			content.push({ type: 'text', text: text.slice(cursor, match.index) });
		}
		content.push({ type: LIQUID_VARIABLE_NODE, attrs: { name: match[1] } });
		cursor = match.index + match[0].length;
	}

	if (cursor < text.length) {
		content.push({ type: 'text', text: text.slice(cursor) });
	}
	return content;
};
